import { Modal, Button, ListGroup } from "react-bootstrap";
// import "./AuthorModal.scss";
import orcidIdIcon from "../assets/orcidIcon.png";

function AuthorModal({ show, onHide, data }) {
  if (!data) return null;

  const { title, doi, journalName, authors, authorsList } = data;
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      // backdrop="static"
    >
      {/* Header */}
      <Modal.Header closeButton>
        <Modal.Title>
          <div style={{ fontSize: "16px", fontWeight: 600 }}>{title}</div>
          <div style={{ fontSize: "13px", color: "#555" }}>
            <div>
              <strong>DOI:</strong>{" "}
              <a href={doi} target="_blank">
                {doi}
              </a>
            </div>
            <div>
              <strong>Journal:</strong> {journalName}
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        <h6 className="mb-3">Authors</h6>
        <ListGroup variant="flush">
          {authorsList.map((author, index) => (
            <ListGroup.Item key={index}>
              <span className="d-flex align-items-end">
                {author.orcid && (
                  <a href={author.orcid} target="_blank">
                    <img
                      // width="10px"
                      height="15px"
                      className="me-1 my-1 text-muted"
                      src={orcidIdIcon}
                      alt="Author id logo"
                    />
                  </a>
                )}
                <span>{author.name}</span>
              </span>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AuthorModal;
